// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.restore-pass-form[data-v-6288ce3e] {\n  display: block;\n  width: 100%;\n  padding: 30px 0 55px;\n}\n.restore-pass-form__note[data-v-6288ce3e] {\n  display: inline-block;\n  width: 100%;\n  margin-top: 15px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
